import { render, staticRenderFns } from "./OchiqMalumot.vue?vue&type=template&id=fe797cee&scoped=true&"
import script from "./OchiqMalumot.vue?vue&type=script&lang=js&"
export * from "./OchiqMalumot.vue?vue&type=script&lang=js&"
import style0 from "./OchiqMalumot.vue?vue&type=style&index=0&id=fe797cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe797cee",
  null
  
)

export default component.exports